'use client';

import React, { useId, useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

interface DataSummaryRow {
  label: React.ReactNode;
  value: number;
}

interface DataSummaryProps {
  rows: DataSummaryRow[];
  testIdPrefix?: string;
}

const DataSummary: React.FC<DataSummaryProps> = ({
  rows,
  testIdPrefix = 'data-summary',
}) => {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div data-testid={testIdPrefix}>
      <div className="border-t border-neutral-200" />
      <button
        type="button"
        className="flex w-full items-center justify-between py-3 text-sm font-medium text-neutral-700"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={panelId}
        data-testid={`${testIdPrefix}-toggle`}
      >
        Data Summary
        <Icon
          icon={open ? faChevronUp : faChevronDown}
          className="h-3.5 w-3.5 text-neutral-500"
          aria-hidden="true"
        />
      </button>
      {open && (
        <div
          id={panelId}
          role="region"
          aria-label="Data Summary"
          className="flex flex-col gap-2 pb-2 text-sm text-neutral-600"
          data-testid={`${testIdPrefix}-content`}
        >
          {rows.map((row, index) => (
            <div key={index} className="flex items-center justify-between">
              <span>{row.label}</span>
              <span className="font-semibold tabular-nums">
                {row.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DataSummary;
